import moment from "moment";
import { AppConstants } from "../../../common/APIConstants";

export const calcOpenEstActualsAttibute = (superProps, selectedFact, chkChng, backData) => {
    let openEst = 0; let openAct = 0; let openAttribute = 0;
    if (['Propane', 'Butane', 'Iso-Butane',
        'Normal Butane', 'Condensate'].includes(selectedFact)) {
        openEst = chkChng(backData?.closingRailcarInvEstimates)
            + chkChng(backData?.closingTankInvEstimates);
        openAct = chkChng(backData?.closingRailcarInvActuals)
            + chkChng(backData?.closingTankInvEstimates);
        openAttribute =
            (moment(superProps.selectedMnthOption) > moment() ? openEst : openAct);
    }
    return { openEst, openAct, openAttribute }
}

export const prepareGridData = (props) => {
    const {
        overUnderViewON,
        openAct,
        openEst,
        selectedMonth,
        data,
        adjustUnit,
        nomRole,
        selectedUOM,
    } = props

    let now = moment().tz(AppConstants.MT_TIME_FORMATTER)
    let nextMonthSixth = moment('06-' + selectedMonth + ' 00:00:01',
        'DD-MMM-YYYY HH:mm:ss', AppConstants.MT_TIME_FORMATTER).add(1, 'M')
    let nominationRole = nomRole
    let currentMonth = moment('01-' + selectedMonth + ' 00:00:01',
        'DD-MMM-YYYY HH:mm:ss', AppConstants.MT_TIME_FORMATTER)
    let UOMDivision = selectedUOM?.division
    let UOMUnit = selectedUOM?.value
    let isOverUnderViewON = overUnderViewON

    const gridIndicators = (now.hour() >= 8 ? now.format('DD-MMM-YYYY') :
        now.add(-1, 'd').format('DD-MMM-YYYY'))
        + '|' + nominationRole + '|' + adjustUnit
        + '|' + (now <= nextMonthSixth) + '|' + (now <= currentMonth)
        + '|' + openEst + '|' + openAct + '|' + UOMDivision + '|' + UOMUnit + '|' +
        isOverUnderViewON;

    const gridData = Object.keys(data).length > 0 ?
        (data.map(obj => ({ ...obj, gridIndicators }))) : []

    return { data: gridData, gridIndicators }
}

export const getBackData = (rawData) => {
    const backData = (typeof rawData?.backData !== 'undefined' &&
        rawData?.backData != null &&
        Object.keys(rawData.backData).length > 0 ? rawData.backData : {})
    return backData
}

export const getRawFooter = (rawData) => {
    let footerRaw = (typeof rawData?.footer !== 'undefined' && rawData?.footer != null
        && Object.keys(rawData.footer).length > 0 ? rawData.footer : {});
    return footerRaw
}

export const getDataRows = (rawData) => {
    return Object.keys(rawData.data).length ? rawData.data : {}
}

export const getPinnedBottomData = async (props) => {
    const {
        superProps,
        footerRaw,
        gridOptions,
        opens,
        customFacility,
        generatePinnedBottomData,
        calculatePinnedBottomData,
        rowData
    } = props

    const openAttribute = (Number(opens.openAttribute) + Number(footerRaw?.unit || 0))

    // props, rawData, gridOpts, facilityOrProd
    let pinnedBottomData = await generatePinnedBottomData(superProps,
        footerRaw, gridOptions, customFacility)

    //target, gridData, openAttribute, customFacility
    pinnedBottomData = await calculatePinnedBottomData(pinnedBottomData, rowData,
        openAttribute, customFacility)

    return pinnedBottomData
}

export const isYear2024OrGreater = (month) => moment(new Date(month)).year() >= 2024

export const isFlowCalAutomated = (month) => {
    const isMonthFebOrGreater = moment(new Date(month)).month() >= 4; // Jan = 0
    const isAutomated = (isMonthFebOrGreater && isYear2024OrGreater(month)) ||
        (moment(new Date(month)).year() > 2024)

    return isAutomated
}

export const isTBossAutomated = (month) => {
    const isMonthJuneOrLater = moment(new Date(month)).month() >= 5 // Jan = 0
    const isAutomated = (isMonthJuneOrLater && isYear2024OrGreater(month)) ||
        (moment(new Date(month)).year() > 2024)

    return isAutomated
}